export default "__VITE_ASSET__cf6d353c__"